import { makeStyles, shorthands } from '@fluentui/react-components';

import { customTokens } from 'src/utils/theme';

export const useCardBackgroundContentStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.padding(
      customTokens.spacingVerticalS,
      customTokens.spacingHorizontalL,
      customTokens.spacingVerticalNone,
      customTokens.spacingHorizontalL,
    ),
  },
  headline: {
    fontSize: customTokens.fontSizeBase450,
    lineHeight: customTokens.lineHeightBase450,
    paddingBottom: customTokens.spacingVerticalXS,
  },
  body: {
    fontSize: customTokens.fontSizeBase300,
    lineHeight: customTokens.lineHeightBase400,
  },
});
